import React from "react";
import "./Techstacks.css";
import { FaReact, FaNodeJs } from "react-icons/fa";
import {
  SiRedux,
  SiHtml5,
  SiMaterialui,
  SiExpress,
  SiRedis,
  //SiTailwindcss,
  SiNetlify,
  SiTypescript,
  SiVercel
  
} from "react-icons/si";
import { DiCss3, DiMongodb,DiFirebase } from "react-icons/di";
import { SiJavascript } from "react-icons/si";
import { VscGithub } from "react-icons/vsc";
import { BsBootstrap } from "react-icons/bs";

export const Techstacks = () => {


  return (
    <div id="skills">
      <div className="section main" data-aos="fade-right">
        <h2 className="section__title different" id="sk">
        Skills</h2>
        <div className="techsection">
          
          <div className="skills-card">
            <SiHtml5 className="skills-card-img"  />
            <h5 className="skills-card-name">HTML</h5>
          </div>
          <div className="skills-card">
            <DiCss3 className="skills-card-img" />
            <h5 className="skills-card-name">CSS</h5>
          </div>
          <div className="skills-card">
            <SiJavascript className="skills-card-img" />
            <h5 className="skills-card-name">Javascript</h5>
          </div>
          <div className="skills-card">
            <FaReact className="skills-card-img" />
            <h5 className="skills-card-name">React</h5>
          </div>
          <div className="skills-card">
            <SiRedux className="skills-card-img" />
            <h5 className="skills-card-name">Redux</h5>
          </div>
          <div className="skills-card">
            <SiTypescript className="skills-card-img" />
            <h5 className="skills-card-name">Typescript</h5>
          </div>
          <div className="skills-card">
            <SiMaterialui className="skills-card-img" />
            <h5 className="skills-card-name">Material Ui</h5>
          </div>
          <div className="skills-card">
            <BsBootstrap className="skills-card-img" />
            <h5 className="skills-card-name">Bootstrap</h5>
          </div>
          <div className="skills-card">
            <SiNetlify className="skills-card-img" />
            <h5 className="skills-card-name">Netlify</h5>
          </div>
         <div className="skills-card">
            <VscGithub className="skills-card-img" />
            <h5 className="skills-card-name">Github</h5>
          </div>
          <div className="skills-card">
            <FaNodeJs className="skills-card-img" />
            <h5 className="skills-card-name">Nodejs</h5>
          </div>
          <div className="skills-card">
            <DiMongodb className="skills-card-img" />
            <h5 className="skills-card-name">MongoDb</h5>
          </div>
          <div className="skills-card">
            <DiFirebase className="skills-card-img" />
            <h5 className="skills-card-name">Firebase</h5>
          </div>

          <div className="skills-card">
            <SiExpress className="skills-card-img" />
            <h5 className="skills-card-name">Express</h5>
          </div>
        </div>
      </div>
    </div>
  );
};
